
import axios from 'axios'
import _ from 'lodash'
import { defineComponent } from 'vue'

export default defineComponent({
	props: ["categoriesprop", "chosencategoryprop"],
	data() { return {
		isSure: false,
		chosenCategory: null as any
	}},
	methods: {
		deleteCategory() {
			if(this.isSure && this.$userIsSuper()) {
				axios.post("Guide/DeleteCategory", this.chosenCategory)
					.then(resp => {
						console.log(resp.data);
						this.$emit("category-deleted")
					})
					.catch(err => {
						console.log(err);
					})
			}
			return
		},
	},
	mounted() {
		this.chosenCategory = _.cloneDeep(this.chosencategoryprop);
	},
})
